module.exports = __webpack_public_path__ + "img/ivmp.6371434a.png";